import React from "react";
import {
  Container,
  Divider,
  Header,
  Icon,
  Segment,
  Table,
} from "semantic-ui-react";
import "./Klima.css";
import AutoAccordion from "./common/AutoAccordion";

const Forside = (props) => (
  <Container text>
    <div style={{ backgroundColor: "white" }}>
      <Header as="h2" textAlign="center">
        Opsparingsmulighed med ekstra fokus på klima{" "}
      </Header>
      <Divider hidden />
      <Segment basic>
        <p>
          Med Klima kan du investere din pensionsopsparing med ekstra fokus på
          klima. Det sker ved, at du vælger investeringsprofil i Livscyklus
          eller investeringskonceptet Fleksibel, og derefter vælger en andel af
          Klima.
        </p>

        <h3>Tre konkrete klimaambitioner</h3>
        <p>
          Når PFA investerer pensionsopsparingerne, er investeringerne baseret
          på ansvarlighed, bæredygtighed og med udgangspunkt i Paris-aftalen og
          FN’s Verdensmål. Med Klima kan du fokusere endnu mere på omstillingen
          til lavemissionsøkonomi, og det er både overskueligt og fleksibelt, da
          Klima har tre konkrete klimaambitioner:
        </p>

        <p>
          <b>
            1. Skærpet CO<sub>2</sub>-fokus
          </b>
          <br />
          Aktieporteføljen i Klima skal udlede 60 procent mindre CO<sub>
            2
          </sub>{" "}
          end verdensaktieindekset målt på den fulde værdikæde. *<br />
        </p>
        <p>
          <b>2. Eksklusion af den fossile sektor</b>
          <br />
          Fra olie, kul og gasselskaber til selskaber med stor tilknytning til
          den fossile sektor.
          <br />
        </p>
        <p>
          <b>
            3. CO<sub>2</sub>-neutralitet** i 2025
          </b>
          <br />
          Fortsat ambition om CO<sub>2</sub>-neutralitet i 2025 og CO
          <sub>2</sub>-negativ i 2030.
        </p>

        <p style={{ fontStyle: "italic", fontSize: 13 }}>
          * MSCI All Countries World Index, CO<sub>2</sub> måles på scope 1,
          scope 2 og scope 3 <br />
          ** Søges opfyldt gennem investering i skov og teknologi, der tager CO
          <sub>2</sub> ud af atmosfæren
        </p>
      </Segment>

      <AutoAccordion activeIndex={-1}>
        <AutoAccordion.Item title="Kort om scope 1, 2 og 3">
          <p>
            EU har udviklet en taksonomi, der definerer, hvilke aktiviteter der
            kan betragtes som bæredygtige. Denne taksonomi kræver, at
            virksomheder rapporterer om deres emissioner (udledninger af
            drivhusgasser og partikler) i henhold til scope 1, 2 og 3 for at
            sikre, at deres aktiviteter bidrager til klimamålene.
          </p>
          <p>
            Scope 1 Direkte emissioner fra kilder, som virksomheden ejer eller
            kontrollerer, f.eks. virksomhedens egne køretøjer og anlæg.
          </p>
          <p>
            Scope 2 Indirekte emissioner fra den elektricitet, varme eller damp,
            virksomheden køber. Disse emissioner opstår ved produktionen af den
            energi, virksomheden bruger.
          </p>
          <p>
            Scope 3 Omfatter alle andre indirekte emissioner, der opstår i
            værdikæden, såsom dem fra leverandører, kunder og produkters
            livscyklus. Scope 3-emissioner er ofte de mest betydningsfulde og
            komplekse at måle og reducere.
          </p>
        </AutoAccordion.Item>
      </AutoAccordion>

      <Segment basic>
        <h3>Sådan sikrer PFA klimamålene</h3>
        <p>
          For at sikre, at PFA holder sig indenfor klimamålene og samtidig
          arbejder for det bedst mulige afkast, så måler PFA løbende CO
          <sub>2</sub>-udledningen på porteføljer og sammenligner med
          verdensindekset. Som modellen viser, udleder aktierne i ekstra
          klimavenlige aktier 75 % mindre CO<sub>2</sub> end verdensindekset,
          mens alle PFA's aktieinvesteringer pt. udleder 42 % mindre CO
          <sub>2</sub>.
        </p>
      </Segment>

      <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
        <h3>Afkast i Klima</h3>
        <p>
          Forvent lidt lavere forventet afkast og større udsving end øvrige
          opsparinger i PFA.
        </p>
        <p>
          De skærpede krav til aktieinvesteringerne gør, at PFA har et mindre
          investeringsunivers end i den øvrige opsparing i PFA. Det betyder, at
          du ved samme profil, dvs. en tilsvarende investeringsrisiko, må
          forvente et lidt lavere afkast og større udsving på kort sigt end din
          øvrige opsparing i PFA. I praksis kan afkastet dog både blive højere,
          det samme eller lavere.
        </p>
      </Segment>

      <Divider hidden />

      <Segment basic>
        <h3>Fakta om Klima</h3>
        <p>
          Klima fondene fremmer den grønne omstilling ved i forbindelse med
          udvælgelsen af investeringerne at have fokus på det bedst mulige
          afkast samt virksomhedernes fokus på omstilling af økonomien til en
          lavemissions-økonomi og dermed reduktion af CO<sub>2</sub>-udledning
          til gavn for klimaet. Derudover inddrages i alle PFA’s produkter
          overholdelse af internationale normer for ansvarlighed inden for
          blandt andet menneskerettigheder, arbejdstagerrettigheder, miljø og
          anti-korruption.
        </p>
        <p>
          Bemærk, at investeringer, der understøtter et lavt CO<sub>2</sub>
          -aftryk. Ikke nødvendigvis er bæredygtige i sig selv.
        </p>

        <h3>
          Sammenligning af almindelig opsparing i PFA og opsparing i Klima
        </h3>

        <Table color="teal" inverted celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Parametre</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                Opsparing i PFA, som ikke er Klima
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Klima</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>
                Ansvarlige investeringer og aktivt ejerskab
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Icon name="checkmark" />
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Icon name="checkmark" />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Ekstra klimafokus</Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell textAlign="center">
                <Icon name="checkmark" />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Eksklusion af fossile brændstoffer *</Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell textAlign="center">
                <Icon name="checkmark" />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                CO<sub>2</sub> emission emission ift. verdensaktieindekset (målt
                på scope 1+2+3)
              </Table.Cell>
              <Table.Cell textAlign="center"></Table.Cell>
              <Table.Cell textAlign="center">60 %</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                Ambition om CO<sub>2</sub> neutral i år (målt på scope 1+2)
              </Table.Cell>
              <Table.Cell textAlign="center">2050</Table.Cell>
              <Table.Cell textAlign="center">2025</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                Ambition om CO<sub>2</sub> negativitet i år (målt på scope 1+2)
              </Table.Cell>
              <Table.Cell textAlign="center"></Table.Cell>
              <Table.Cell textAlign="center">2030</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                Forventet afkast ift. opsparing som ikke er Klima**
              </Table.Cell>
              <Table.Cell textAlign="center"></Table.Cell>
              <Table.Cell textAlign="center">
                Lidt lavere langsigtet forventet afkast
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <p style={{ fontStyle: "italic", fontSize: 13 }}>
          *Det er en eksklusion af olie, gas og kulselskaber (eksklusion af GICS
          energy-klassificering + BICS Energy ex. Renewables) samt eksklusioner
          ift. Paris-aligned benchmark.
        </p>
        <p style={{ fontStyle: "italic", fontSize: 13 }}>
          **De skærpede adgangskrav gør, at Klima må forvente at operere i et
          endnu mindre investeringsunivers end for de øvrige investeringer. Det
          betyder, at man ved samme investeringsrisiko skal forvente et lidt
          lavere afkast og større udsving på kort sigt end for de øvrige
          investeringer. I praksis kan afkastet dog både blive højere, det samme
          eller lavere.
        </p>
      </Segment>

      <h4>Læs mere om, hvordan PFA arbejder med ansvarlige investeringer</h4>
      <p>
        <a
          href="https://www.pfa.dk/om-pfa/samfundsansvar/politik-og-retningslinjer"
          target="_blank"
          rel="noreferrer"
        >
          Politik og retningslinjer for ansvarlige investeringer
        </a>
      </p>
      <p>
        <a
          href="https://www.pfa.dk/om-pfa/samfundsansvar/aktivt-ejerskab"
          target="_blank"
          rel="noreferrer"
        >
          Aktivt ejerskab
        </a>
      </p>

      <Divider hidden />
    </div>
  </Container>
);

export default Forside;
